import React, {
    ReactElement,
    ChangeEvent,
    useState,
    useEffect,
    SetStateAction,
    Dispatch,
} from 'react';

import { getAssetBaseUrl } from '../utils';

import { checkBoxDisplayName } from './CheckBox.qa';

const assetBaseURL = getAssetBaseUrl();
const checkMarkAsset: string = `${assetBaseURL}/checkbox_check_mark.svg`;

export interface ICheckBoxProps {
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onClick?: () => void;
    disabled?: boolean;
    'data-testid'?: string;
    className?: string;
    checked?: boolean;
    name?: string;
    htmlId: string;
}

interface ICheckedEvent {
    target: {
        checked: boolean;
    };
}

export function OzCheckBox (props: ICheckBoxProps): ReactElement {
    const {
        disabled = false,
        'data-testid': dataTestId = '',
        className = '',
        onClick,
        onChange,
        name,
        checked: defaultChecked = false,
        htmlId,
    }: ICheckBoxProps = props;

    const [checked, setChecked]: [
        boolean,
        Dispatch<SetStateAction<boolean>>
    ] = useState<boolean>(defaultChecked);

    useEffect((): void => {
        setChecked(defaultChecked);
    }, [defaultChecked]);

    function handleChange (event: ChangeEvent<HTMLInputElement>): void {
        const { target }: ICheckedEvent = event;

        setChecked(target.checked);

        if (onChange) {
            onChange(event);
        }
    }

    return (
        <div className="absolute h-3">
            <input
                data-testid={dataTestId}
                type="checkbox"
                disabled={disabled}
                onChange={handleChange}
                onClick={onClick}
                className={
                    `cursor-pointer w-3 h-3 rounded bg-primary-contrast border border-solid border-black-50
                    appearance-none checked:border-primary checked:bg-primary hover:border-primary
                    disabled:border-black-30 disabled:cursor-not-allowed ${className}`
                }
                checked={checked}
                id={htmlId}
                name={name}
            />
            <img
                src={checkMarkAsset}
                alt=""
                className={
                    'absolute transform -translate-x-1/2 -translate-y-1/2 pointer-events-none top-50% left-50%'
                }
            />
        </div>
    );
}

OzCheckBox.displayName = checkBoxDisplayName;
